import { render } from "./MyPlatformInvoices.vue?vue&type=template&id=2b64accd&scoped=true"
import script from "./MyPlatformInvoices.vue?vue&type=script&lang=js"
export * from "./MyPlatformInvoices.vue?vue&type=script&lang=js"

import "./MyPlatformInvoices.vue?vue&type=style&index=0&id=2b64accd&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/SIMI-TRAC/SIMI-TRAC-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b64accd"]])

export default __exports__